module.exports = __webpack_public_path__ + "static/media/CeraPro-Italic.bd694d48.woff2";